import { createSlice } from "@reduxjs/toolkit";
import urlStorage from "src/support/urlStorage";

const urlList = urlStorage.getItem('qt');

const initialState = {
    filterList: urlList ? urlList : []
};

const slice = createSlice({
    name: "filterSelection",
    initialState: initialState,
    reducers: {
        setFilterList: {
            reducer: (state, action) => {
                state.filterList = action.payload
                urlStorage.setItem('qt', state.filterList);
            },
        },
        clearFilterByKey: {
            reducer: (state, action) => {
                state.filterList.splice(action.payload, 1);
                if (Object.entries(state.filterList).length > 0) {
                    urlStorage.setItem('qt', state.filterList);
                } else {
                    urlStorage.removeItem('qt');
                }
                return state;
            },
        },
        clearAllFilter: {
            reducer: (state, action) => {
                state.filterList = [];
                urlStorage.removeItem('qt');
                return state;
            },
        },
        clearArryVal: {
            reducer: (state, action) => {
                let data = action.payload.data;
                let _ary = state.filterList.find(f => f.searchKey === data.key).searchKeywordArr;
                if (_ary.length === 1) {
                    let idx = state.filterList.findIndex(f => f.searchKey === data.key)
                    state.filterList.splice(idx);
                }
                else {
                    state.filterList.forEach((ele, i) => {
                        if (ele.searchKey === data.key) {
                            ele.searchKeywordArr = ele.searchKeywordArr.filter(f => f !== data.val);
                        }
                    })
                }
                urlStorage.setItem('qt', state.filterList);
                return state;
            },
        },
    },
});

export let { setFilterList, clearFilterByKey, clearAllFilter, clearArryVal } = slice.actions;

export default slice.reducer;
